export default __webpack_public_path__ + "static/media/shape3.a14d1586.png";